import React from 'react';
import './EmailTemplatesList.css';

const EmailTemplatesList = ({ templates, onCreateTemplate, onEditTemplate }) => {
    const formatDate = (timestamp) => {
        if (!timestamp) return 'Unknown';
        return new Date(timestamp).toLocaleDateString('de-DE', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    if (templates.length === 0) {
        return (
            <div className="email-templates-empty">
                <div className="empty-icon">📧</div>
                <h3>No Email Templates Yet</h3>
                <p>Create your first email template to use in your email flows.</p>
                <div className="empty-actions">
                    <button 
                        className="email-flow-btn primary"
                        onClick={onCreateTemplate}
                    >
                        Create Your First Template
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="email-templates-section">
            <div className="email-templates-grid">
                {templates.map(template => (
                    <div key={template.id} className="email-template-card">
                        <div className="template-card-header">
                            <h4>{template.name}</h4>
                            <span className="template-date">
                                {formatDate(template.updatedAt || template.createdAt)}
                            </span>
                        </div>
                        
                        <p>{template.description || 'No description'}</p>
                        
                        <div className="template-preview">
                            {template.html ? (
                                <div 
                                    className="template-html-preview"
                                    dangerouslySetInnerHTML={{ 
                                        __html: template.html.substring(0, 200) + '...' 
                                    }}
                                />
                            ) : (
                                <div className="template-no-preview">
                                    📧 Email Template
                                </div>
                            )}
                        </div>
                        
                        <div className="template-actions">
                            <button 
                                className="template-action-btn edit"
                                onClick={() => onEditTemplate(template.id)}
                            >
                                ✏️ Edit
                            </button>
                            <button 
                                className="template-action-btn preview"
                                onClick={() => {
                                    if (template.html) {
                                        const previewWindow = window.open('', '_blank');
                                        previewWindow.document.write(template.html);
                                        previewWindow.document.close();
                                    }
                                }}
                                disabled={!template.html}
                            >
                                👁️ Preview
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EmailTemplatesList;
